import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EntityList } from 'src/app/models';
import { Location } from 'src/app/models/location';
import { RelevanceStatus } from 'src/app/models/relevance-status';
import { ActionConfirmer } from 'src/app/util/confirmation';
import { ActionConfirmationService } from 'src/app/util/confirmation/confirmation.service';
import { MessageEventService } from 'src/app/util/message-event.service';
import { AlertsLocationService } from '../../services/alerts-location.service';

@Component({
  selector: 'app-location-alerts-list',
  templateUrl: './location-alerts-list.component.html',
  styleUrls: ['./location-alerts-list.component.scss'],
})
export class LocationAlertsListComponent implements OnDestroy, OnChanges {
  @Input() entityList: EntityList<Location>;
  @Input() tableId: string;
  @Input() displayedColumns: string[];
  @Output() pageEvent = new EventEmitter<any>();
  @Output() reload = new EventEmitter<void>();

  private subscription = new Subscription();

  private actionConfirmer: ActionConfirmer;

  constructor(
    private locationsService: AlertsLocationService,
    private messageService: MessageEventService,
    dialog: MatDialog,
    private router: Router
  ) {
    this.actionConfirmer = new ActionConfirmationService(dialog);
  }

  onPageEvent(event) {
    this.pageEvent.emit(event);
  }

  onUnconfirmedActionComplete() {
    this.reload.emit();
  }

  // confirmLocation confirms location then reloads the alerts list
  confirmLocation(location: Location) {
    this.subscription.add(
      this.actionConfirmer.confirmAction(
        `Are you sure you want to confirm ${location.name}?`,
        () => {
          this.subscription.add(
            this.locationsService.confirmLocation(location).subscribe(() => {
              this.messageService.pushEvent({
                message: `Location ${location.name} confirmed`,
                status: 'success',
              });
              this.reload.next();
            })
          );
        }
      )
    );
  }

  // ignoreLocation ignores the location then reloads the alert list
  ignoreLocation(location: Location) {
    this.subscription.add(
      this.actionConfirmer.confirmAction(
        `Are you sure you want to ignore ${location.name}?`,
        () => {
          this.subscription.add(
            this.locationsService.ignoreLocation(location).subscribe(() => {
              this.messageService.pushEvent({
                message: `Location ${location.name} ignored`,
                status: 'success',
              });
              this.reload.next();
            })
          );
        }
      )
    );
  }

  isUnconfirmed(location: Location): boolean {
    return location.tracking?.asset_status === RelevanceStatus.Unconfirmed;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnChanges(): void {
    // If alerts list is empty redirct to the alerts centre page
    if (this.entityList.loading === false && this.entityList.total === 0) {
      this.router.navigateByUrl('/notifications');
    }
  }
}
